import React, { useState } from "react";
import { useEffect } from "react";
import { Container, Form, Row, Col, InputGroup } from "react-bootstrap";
import { connect } from "react-redux";
import { addUserRes } from "./user.actions";
import { getRestaurantData } from "../AddDetails/AddResturant/Resturant.action";
import { getWarehouseWithResApi } from "../AddDetails/Warehouse/Warehouse.action";
import { setHeading } from "../../accounts/account.actions";
import { isEmpty, toLower } from "lodash";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../global/globalFunctions";
import Select from "react-select";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';


const AddUser = (props) => {
  // const [firstName, setFirstName] = useState("");
  // const [lastName, setLastName] = useState("");
  const [userName, setUserName] = useState("");
  const [passwordUser, setPasswordUser] = useState("");
  const [roleName, setRoleName] = useState("");
  const [restaurantId, setRestaurantId] = useState("");
  const [restaurantname, setRestaurantName] = useState("");
  const [warehouseId, setWarehouseId] = useState();
  const [warehouseName, setWarehouseName] = useState();
  const [showPassword, setShowPassword] = useState(false);


  function SaveUser() {
    props.addUser({
      // firstName: firstName,
      // lastName: lastName,
      userName: userName,
      password: passwordUser,
      role: toLower(roleName),
      restaurant: restaurantId,
      restaurantname: restaurantname,
      wareHouseId: warehouseId,
      warehouseName: warehouseName,
    },
      showSuccessAlert,
      showErrorAlert,
    );
    // setLastName("");
    // setFirstName("");
    setPasswordUser("");
    setUserName("");
    setRestaurantName("")
    setWarehouseName("")
    setRoleName("")
  }

  let rollData = [
    {
      roll_id: 1,
      roll_name: "Admin",
    },
    {
      roll_id: 2,
      roll_name: "Manager",
    },
    {
      roll_id: 3,
      roll_name: "Employee",
    },
    {
      roll_id: 4,
      roll_name: "Booker",
    }
  ];
  const handleChangeRoll = (selectedOption) => {
    // setEventShiftId(selectedOption.value);
    setRoleName(selectedOption.label);
  };
  const rollList = rollData.map((x) => {
    let data = { value: x.roll_id, label: x.roll_name };
    return data;
  });

  const handleChangeRestaurant = (selectedOption) => {
    setRestaurantId(selectedOption.value);
    setRestaurantName(selectedOption.label);
    props.getWarehouseWithResApi(selectedOption.value);
  };
  const getRestaurantList = isEmpty(props.restaurantDataList) ? [] : props.restaurantDataList.map((x) => {
    let data = { value: x._id, label: x.restaurantName };
    return data;
  });

  const handleChangeWarehouse = (selectedOption) => {
    setWarehouseId(selectedOption.value);
    setWarehouseName(selectedOption.label);
  };
  const getWarehouseList = isEmpty(props.warehouseListWithResId.data) ? [] : props.warehouseListWithResId.data.map((x) => {
    let data = { value: x._id, label: x.businessName };
    return data;
  });

  useEffect(() => {
    props.setHeading("Add User")
    props.getRestaurantData()
  }, []);

  return (
    <>
      {props.isFetchingRestaurant || props.isAddingUser ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Form>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Company *</b> </Form.Label>
                  <Select
                    isDisabled={isEmpty(props.restaurantDataList)}
                    placeholder="Select Company"
                    onChange={handleChangeRestaurant}
                    options={getRestaurantList}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Select Business Location *</b></Form.Label>
                  <Select
                    placeholder="Select Business Location"
                    isDisabled={isEmpty(props.warehouseListWithResId) || isEmpty(restaurantId)}
                    onChange={handleChangeWarehouse}
                    options={getWarehouseList}
                  />
                </Form.Group>
              </Col>
            </Row>
            {/* <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>First Name </b></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Last Name</b> </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row> */}
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>User Name *</b></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="User Name"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Password *</b></Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      minLength={8}
                      placeholder="Password"
                      value={passwordUser}
                      onChange={(e) => setPasswordUser(e.target.value)}
                    />
                    <InputGroup.Text
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ cursor: "pointer" }}
                    >
                      {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Role *</b> </Form.Label>
                  <Select
                    isDisabled={isEmpty(rollData)}
                    placeholder="Select Role"
                    onChange={handleChangeRoll}
                    options={rollList}
                  />
                </Form.Group>
              </Col>
              <Col></Col>
            </Row>

            <div className="sendDiv">
              {isEmpty(userName) || isEmpty(passwordUser) || isEmpty(restaurantId) || isEmpty(roleName) || isEmpty(warehouseId) ? (
                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
              ) : (
                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveUser}> SAVE </Button>
              )}
            </div>

          </Form>
        </Container>)}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addUser: (data, showSuccessAlert, showErrorAlert) => dispatch(addUserRes(data, showSuccessAlert, showErrorAlert)),
    getRestaurantData: () => dispatch(getRestaurantData()),
    setHeading: (data) => dispatch(setHeading(data)),
    getWarehouseWithResApi: (id) => dispatch(getWarehouseWithResApi(id)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  addUser: state.UserReducer.addUser,
  isAddingUser: state.UserReducer.isAddingUser,
  restaurantDataList: state.ResturantReducer.restaurantDataList,
  isFetchingRestaurant: state.ResturantReducer.isFetchingRestaurant,
  warehouseListWithResId: state.WarehouseReducer.warehouseListWithResId,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddUser);